export const loadScripts = async (carouselBool) => {
    if (document.querySelector(".charts-above-the-fold")) {
        // Highcharts Block
        if (document.querySelector(".highcharts-block-js")) {
            await import("../highcharts-block.js");
        }

        // Performance Charts (highcharts)
        if (document.querySelector(".performance-chart-block-js")) {
            await import("../../../../eu/js/src/sources/performance-charts.js");
        }
    }

    // Carousels
    // if (document.querySelector(".carousels-above-the-fold") && carouselBool) {
        await import("./carousels.js");
    // }
}

export const loadScrollDelayedScripts = async (carouselBool) => {
    // Expandable Nav
    if (document.querySelector("ve-expandablemenu") && !window.ExpandableMenu) {
        window.ExpandableMenu = true;
        await import("../override/expandable-menu/expandable-nav.js");
    }

    if (!document.querySelector(".charts-above-the-fold")) {
        // Highcharts Block
        if (document.querySelector(".highcharts-block-js")) {
            await import("../highcharts-block.js");
        }

        // Performance Charts (highcharts)
        if (document.querySelector(".performance-chart-block-js")) {
            await import("../../../../eu/js/src/sources/performance-charts.js");
        }
    }

    // Carousels
    if (!document.querySelector(".carousels-above-the-fold") && carouselBool) {
        await import("./carousels.js");
    }
}

export const loadHeaderSearch = async () => {
    await import("../override/search.js");
}